import { render } from "./ModuloNode.vue?vue&type=template&id=65ae98cc"
import script from "./ModuloNode.vue?vue&type=script&lang=js"
export * from "./ModuloNode.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__